import { render, staticRenderFns } from "./AccompagnementNew.vue?vue&type=template&id=bd19e5bc&"
import script from "./AccompagnementNew.vue?vue&type=script&lang=js&"
export * from "./AccompagnementNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports